import { BASE_API_AUTH_URL, BASE_API_URL, BASE_API_URL2 } from "../../config";
import Repository from "../helper/HttpHelper";

export const styleTableMantine = {
  fontWeight: 550,
  fontSize: "12px",
  padding: "6px 8px",
};

export const _timerDelaySearch: number = 1;
export const repositoryMaster = new Repository(BASE_API_AUTH_URL);
export const repositoryWeb = new Repository(BASE_API_URL);
export const repositoryCart = new Repository(BASE_API_URL2);
